import { trackPageScrollDepthReached } from "app/utils/mixpanel_tracking"

export const SCROLL_DEPTH_MILESTONES = [25, 50, 75, 100]

const scrolledPercent = () => {
  const { scrollHeight } = document.documentElement
  const bottom = window.scrollY + window.innerHeight
  // Zoom and mobile toolbars give fractional scroll positions that stop short of the last pixel.
  if (bottom >= scrollHeight - 1) return 100

  return (bottom / scrollHeight) * 100
}

// Tracks each milestone once per page view; returns a teardown.
export const watchScrollDepth = (page: string) => {
  const pending = [...SCROLL_DEPTH_MILESTONES]
  let frame: number | undefined

  const check = () => {
    frame = undefined
    const percent = scrolledPercent()
    while (pending.length > 0 && percent >= pending[0]) {
      trackPageScrollDepthReached({ page, depthPercent: pending.shift() as number })
    }
    if (pending.length === 0) teardown()
  }

  const onScroll = () => {
    frame ??= window.requestAnimationFrame(check)
  }

  const teardown = () => {
    window.removeEventListener("scroll", onScroll)
    if (frame !== undefined) window.cancelAnimationFrame(frame)
  }

  window.addEventListener("scroll", onScroll, { passive: true })
  check()

  return teardown
}
